import React,{useState} from 'react';
import './navbar.css'
import {SiYourtraveldottv} from "react-icons/si";
import {AiFillCloseCircle} from "react-icons/ai";
import {TbGridDots} from "react-icons/tb";
import { Link } from 'react-router-dom';

const Navbar = () => {
  const [active, setActive] = useState('navbar')
  const showNav =()=>{
    setActive('navbar activeNavbar');
  }
  const removeNav =()=>{
    setActive('navbar');
  }

  const [transparent,setTransparent]=useState('header')
  const addBg =()=>{
    if(window.scrollY >= 10){
      setTransparent('header activeHeader')
    }else{
      setTransparent('header')
    }
  }
  window.addEventListener("scroll",addBg)

  return (
    <div>
      <section className="navbarSection">
        <div className={transparent}>
          <div className="logoDiv">
            <a href="/" className="logo">
              <h1 className='flex'><SiYourtraveldottv className="logoIcon"/>Happy Safar</h1>
            </a>
          </div>
          <div className={active}>
            <ul className="navLists flex">
              <li className="navItem">
                <a href="#Home" className="navLink">Home</a>
              </li>
              <li className="navItem">
                <a href="#Popular" className="navLink">Popular</a>
              </li>
              <li className="navItem">
                <a href="#Offers" className="navLink">Offers</a>
              </li>
              <li className="navItem">
                <a href="#About" className="navLink">About</a>
              </li>
              <li className="navItem">
                <a href="#Blog" className="navLink">Blog</a>
              </li>
              <div className="headerBtns flex">
                <Link to={'/Login'}>
                  <button className="btn loginBtn">
                    <a href="/Login">Login</a>
                  </button>
                </Link>
                <Link to={'/SignUp'}>
                  <button className="btn">
                    <a href="/SignUp">Sign Up</a>
                  </button>
                </Link>
              </div>
            </ul>
            <div onClick={removeNav} className="closeNavbar">
              <AiFillCloseCircle className="icon"/>
            </div>
          </div>
          <div onClick={showNav} className="toggleNavbar">
            <TbGridDots className='icon'/>
          </div>
        </div>
      </section>
    </div>
  )
}

export default Navbar